import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useTournament } from "@/lib/TournamentContext";
import { toast } from "sonner";

function QuestionCard({ q }) {
  const [answer, setAnswer] = useState(null);
  const [saved, setSaved] = useState(null);

  useEffect(() => {
    api.get(`/bonus-questions/${q.question_id}/my-answer`).then((r) => {
      setAnswer(r.data.answer || null);
      setSaved(r.data.answer || null);
    });
  }, [q.question_id]);

  const save = async () => {
    if (!answer) return;
    try {
      await api.post(`/bonus-questions/${q.question_id}/answer`, { answer });
      setSaved(answer);
      toast.success("Answer locked in");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="surface-card p-5" data-testid={`bonus-${q.question_id}`}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display text-xl">{q.question}</h3>
        <span className="text-xs uppercase tracking-widest text-primary-accent">+{q.points} pts</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-3">
        {q.options.map((opt) => (
          <button
            key={opt}
            data-testid={`opt-${q.question_id}-${opt}`}
            disabled={q.locked}
            onClick={() => setAnswer(opt)}
            className={`p-3 border text-left ${answer === opt ? "bg-primary-accent border-primary-accent text-white" : "border-zinc-800 hover:border-white/30"}`}
          >{opt}</button>
        ))}
      </div>
      {!q.locked && (
        <button
          data-testid={`save-bonus-${q.question_id}`}
          onClick={save}
          disabled={!answer || answer === saved}
          className="bg-primary-accent text-white px-4 py-2 text-xs uppercase tracking-widest disabled:opacity-50"
        >{saved && saved === answer ? "Saved" : "Save Answer"}</button>
      )}
      {q.locked && q.answer && (
        <div className="text-xs uppercase tracking-widest text-zinc-400">
          Correct: <span className="text-primary-accent">{q.answer}</span>
        </div>
      )}
    </div>
  );
}

export default function Bonus() {
  const { active } = useTournament();
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (!active) return;
    api.get(`/tournaments/${active.tournament_id}/bonus-questions`).then((r) => setQuestions(r.data));
  }, [active]);

  if (!active) return null;

  return (
    <div className="px-3 md:px-8 py-6 md:py-8 grid-bg min-h-[calc(100vh-65px)]">
      <div className="mb-6">
        <div className="label-tag mb-1">Tournament-Long Picks</div>
        <h1 className="font-display text-4xl md:text-5xl uppercase">Bonus Questions</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {questions.map((q) => <QuestionCard key={q.question_id} q={q} />)}
      </div>
      {questions.length === 0 && <div className="text-zinc-500">No bonus questions configured.</div>}
    </div>
  );
}
